import React from "react";
import {message, Modal} from "antd";
import {forgotPassword} from "../api/auth";

interface ForgotPasswordModalProps {
    open: boolean;
    onCancel: () => void;
}

const ForgotPasswordModal: React.FC<ForgotPasswordModalProps> = ({open, onCancel}) => {

    return (
        <Modal
            open={open}
            onCancel={onCancel}
            footer={null}
            title="Réinitialiser votre mot de passe"
        >
            <span>Saisir votre adresse mail</span>
            <form onSubmit={(e) => {
                e.preventDefault();
                // Handle password reset logic here
                console.log("Password reset requested");

                // Récupération de l'email depuis le formulaire
                const email = (e.target as HTMLFormElement).email.value;
                forgotPassword(email)
                    .then(() => {
                        message.success("Password reset email sent")
                            .then(() => {
                            });
                    })
                    .catch((error) => {
                        void message.error(`Error sending password reset email: ${error}`);
                    });

                onCancel(); // Close the modal after submission
            }}>
                <input
                    type="email"
                    name="email"
                    placeholder="Entrez votre email"
                    required
                    style={{width: '100%', padding: '8px', marginTop: '10px'}}
                />
                <button type="submit" style={{marginTop: '10px', padding: '8px 16px'}}>
                    Envoyer le lien de réinitialisation
                </button>
            </form>
        </Modal>
    );
}

export default ForgotPasswordModal;